import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Qualifier } from "../../../internal/qualifier/Qualifier";
import { Action } from "../../../internal/Action";
/**
 * @description The Action class of the blur Builder.
 * @extends SDK.Action
 * @memberOf Actions.Effect
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var BlurAction = /*#__PURE__*/function (_Action) {
  _inherits(BlurAction, _Action);

  var _super = _createSuper(BlurAction);

  function BlurAction(strength) {
    var _this;

    _classCallCheck(this, BlurAction);

    _this = _super.call(this);
    _this._strength = strength;
    return _this;
  }
  /**
   * @description Specifies the region to blur.
   * @param {NamedRegion} blurRegion
   */


  _createClass(BlurAction, [{
    key: "region",
    value: function region(blurRegion) {
      this._region = blurRegion;
      return this;
    }
    /**
     * @description Sets the strength of the blur effect.
     * @param {number | string} strength
     */

  }, {
    key: "strength",
    value: function strength(_strength) {
      this._strength = _strength;
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      var _this2 = this;

      /*
       * Blur with region is a unique object in this codebase.
       * On top of Blur being an Action with Qualifiers,
       * it also accepts a Qualifier called Region.
       *
       * This Qualifier is in itself composite of qualifiers (such as height, or width).
       * The existence of Region changes the output of Blur in non traditional ways
       * which forced this relatively ad-hoc implementation.
       *
       * Aside from all of that, all of the Qualifiers in the component should be alphabetized
       * This happens naturally in the Action class,
       * however since we're dealing with two levels of qualifiers (Blur and Region),
       * these need to be merged.
       *
       * This function will merge the Region qualifiers with Blur
       * and add all needed implicit qualifiers (like g_ocr_text).
       * We're not using the full Gravity Qualifier here to prevent the code import for such a simplistic case
       */
      var str = this._strength ? ":".concat(this._strength) : '';

      if ('_region' in this) {
        var qualifiers = this._region.qualifiers; // Copy qualifiers from the region "action" to the blur action

        qualifiers.forEach(function (q) {
          return _this2.addQualifier(q);
        });

        if (this._region.regionType === 'named') {
          this.addQualifier(new Qualifier('e', "blur_region".concat(str)));
        }

        if (this._region.regionType === 'ocr_text') {
          this.addQualifier(new Qualifier('e', "blur_region".concat(str)));
          this.addQualifier(new Qualifier('g', "ocr_text"));
        }

        if (this._region.regionType === 'faces') {
          this.addQualifier(new Qualifier('e', "blur_faces".concat(str)));
        }
      } else {
        this.addQualifier(new Qualifier('e', "blur".concat(str)));
      }
    }
  }]);

  return BlurAction;
}(Action);

export { BlurAction };